var React = require('react');

function WhitePlus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.83368 12.666C7.83368 13.0342 8.13215 13.3327 8.50034 13.3327C8.86853 13.3327 9.16701 13.0342 9.16701 12.666V8.66602H13.167C13.5352 8.66602 13.8337 8.36754 13.8337 7.99935C13.8337 7.63116 13.5352 7.33268 13.167 7.33268H9.16701V3.33268C9.16701 2.96449 8.86853 2.66602 8.50034 2.66602C8.13215 2.66602 7.83368 2.96449 7.83368 3.33268V7.33268H3.83366C3.46547 7.33268 3.16699 7.63116 3.16699 7.99935C3.16699 8.36754 3.46547 8.66602 3.83366 8.66602H7.83368V12.666Z","fill":"white"}));
}

WhitePlus.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = WhitePlus;

WhitePlus.default = WhitePlus;
